import styled from 'styled-components'

import {Container} from '~/components/general/container/Container'

export const StyledSelect = styled.select`
  width: 100%;
  max-width: 600px;
  padding: 12px 15px;
  font-size: ${({theme}) => theme.fontSize.lg};
  line-height: ${({theme}) => theme.lineHeight.lg};
  color: ${({theme}) => theme.colors.inputText};
  background-color: ${({theme}) => theme.colors.white};
  border: 1px solid ${({theme}) => theme.colors.inputBorder};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  outline: none;
  cursor: pointer;

  &:focus {
    border-color: ${({theme}) => theme.colors.primary.main};
  }

  &:disabled {
    background-color: ${({theme}) => theme.colors.grey.grey20};
    cursor: not-allowed;
  }
`

export const InputWrapper = styled.div`
  width: 100%;
  max-width: 800px;
`

export const TestEmailInputWrapper = styled.div`
  width: 300px;
`

export const TestInputContainer = styled(Container)`
  gap: 8px;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid ${({theme}) => theme.colors.inputBorder};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  background-color: ${({theme}) => theme.colors.grey.grey20};
`

export const ButtonsContainer = styled(Container)`
  gap: 12px;
  justify-content: space-between;
`

export const LeftButtonsContainer = styled(Container)`
  gap: 12px;
`

export const TestButtonWrapper = styled.div<{disabled: boolean}>`
  opacity: ${({disabled}) => (disabled ? 0.5 : 1)};
  cursor: ${({disabled}) => (disabled ? 'not-allowed' : 'pointer')};
`

export const HelpContent = styled(Container)`
  flex-direction: column;
  gap: 16px;
`

export const HelpSection = styled(Container)`
  flex-direction: column;
  gap: 8px;
`

export const PlaceholderList = styled.ul`
  margin: 0;
  padding-left: 20px;
`

export const PlaceholderItem = styled.li`
  margin-bottom: 8px;
  font-family: monospace;
  background-color: ${({theme}) => theme.colors.grey.grey20};
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
`
